import { render, staticRenderFns } from "./IconReferral.vue?vue&type=template&id=f079b716&scoped=true"
import script from "./IconReferral.vue?vue&type=script&lang=js"
export * from "./IconReferral.vue?vue&type=script&lang=js"
import style0 from "./IconReferral.vue?vue&type=style&index=0&id=f079b716&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f079b716",
  null
  
)

export default component.exports